document.addEventListener("DOMContentLoaded", () => {
  let target = $(".nav-6th-content").offset().top;
  $(window).scroll(function () {
    let scrollTop = $(window).scrollTop();
    if (scrollTop >= target) {
      $(".nav-6th-content").addClass("fix_top");
      $("sticky-header.header-wrapper").hide();
    } else if (scrollTop < target) {
      $(".nav-6th-content").removeClass("fix_top");
      $("sticky-header.header-wrapper").show();
    }
  });

  var status = true;

  $(".nav-6th-content .nav-block").on("click", function (e) {
    $(".nav-6th-content .nav-block").removeClass("slide");
    $(this).addClass("slide");

    status = false;

    setTimeout(function () {
      status = true;
    }, 500);
  });

  var $elements = $(".nav-block");
  var $modules = $(".nav-module");
  let slider = document.querySelector('.nav-6th-content');
  function setActiveElement() {
    var scrollPosition = $(window).scrollTop();

    if (status) {
      $modules.each(function (index) {
        var $module = $(this);
        var moduleTop = $module.offset().top - 150;
        var moduleHeight = $module.outerHeight();

        if (
          scrollPosition >= moduleTop &&
          scrollPosition < moduleTop + moduleHeight && 
          !$elements.eq(index).hasClass("slide")
        ) {
          $elements.removeClass("slide");
          $elements.eq(index).addClass("slide");
          slider.scrollLeft = $elements.eq(index).offset().left;
        }
      });
    }
  }

  $(window).on("scroll", setActiveElement);

  setActiveElement();
});
